module.exports = __webpack_public_path__ + "img/account_webshop.3c23563.svg";